/* __next_internal_client_entry_do_not_use__ useRecordMilestone,useMilestone,useRecordMilestoneOnce,useRecordMilestoneByDay,useIsMilestoneOverWeekOld,useIsMilestoneOverDaysOld auto */ import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getUser } from "@faire/retailer-visitor-shared/serialized-data/getUser";
import { getUserMilestones } from "@faire/retailer-visitor-shared/serialized-data/getUserMilestones";
import { useQuery as useMilestonesQuery, getQueryKey as getMilestonesQueryKey } from "@faire/web-api--source/api/user/milestones/userToken/list/get-hooks";
import { useMutation as useMilestoneMutation } from "@faire/web-api--source/api/user/milestones/userToken/post-hooks";
import { IGetUserMilestonesResponse } from "@faire/web-api--source/indigofair/data/IGetUserMilestonesResponse";
import { IUserMilestone } from "@faire/web-api--source/indigofair/data/IUserMilestone";
import { useQueryClient } from "@tanstack/react-query";
import differenceInDays from "date-fns/differenceInDays";
import { useCallback, useMemo } from "react";
var getInitialMilestoneData = function() {
    var milestones = getUserMilestones();
    if (!milestones) {
        return undefined;
    }
    return IGetUserMilestonesResponse.build({
        milestones: milestones.reduce(function(acc, milestone) {
            return _object_spread_props(_object_spread({}, acc), _define_property({}, milestone.retailer_milestone, milestone));
        }, {})
    });
};
var useMilestonesData = function() {
    var _getUser;
    var userToken = (_getUser = getUser()) === null || _getUser === void 0 ? void 0 : _getUser.token;
    var data = useMilestonesQuery(userToken !== null && userToken !== void 0 ? userToken : "", {
        initialData: getInitialMilestoneData(),
        enabled: !!userToken,
        staleTime: Infinity
    }).data;
    return data === null || data === void 0 ? void 0 : data.milestones;
};
export function useRecordMilestone() {
    var _getUser;
    var userToken = (_getUser = getUser()) === null || _getUser === void 0 ? void 0 : _getUser.token;
    var mutateAsync = useMilestoneMutation().mutateAsync;
    var queryClient = useQueryClient();
    return useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(milestoneType) {
            return _ts_generator(this, function(_state) {
                if (!userToken) {
                    return [
                        2,
                        Promise.resolve()
                    ];
                }
                return [
                    2,
                    mutateAsync([
                        userToken,
                        IUserMilestone.build({
                            retailer_milestone: milestoneType
                        })
                    ]).then(function(updatedMilestone) {
                        queryClient.setQueryData(getMilestonesQueryKey(userToken), function(prev) {
                            return IGetUserMilestonesResponse.build({
                                milestones: _object_spread_props(_object_spread({}, prev === null || prev === void 0 ? void 0 : prev.milestones), _define_property({}, milestoneType, updatedMilestone))
                            });
                        });
                    })
                ];
            });
        });
        return function(milestoneType) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutateAsync,
        queryClient,
        userToken
    ]);
}
export var useMilestone = function(milestoneType) {
    var _milestones_milestoneType;
    var milestones = useMilestonesData();
    var count = (milestones === null || milestones === void 0 ? void 0 : (_milestones_milestoneType = milestones[milestoneType]) === null || _milestones_milestoneType === void 0 ? void 0 : _milestones_milestoneType.count) || 0;
    var hasOccurred = count > 0;
    var record = useRecordMilestone();
    var setHasOccurred = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            if (!hasOccurred) {
                record(milestoneType);
            }
            return [
                2,
                Promise.resolve()
            ];
        });
    }), [
        hasOccurred,
        record,
        milestoneType
    ]);
    var incrementCount = useCallback(function() {
        return record(milestoneType);
    }, [
        record,
        milestoneType
    ]);
    return useMemo(function() {
        return {
            hasOccurred: hasOccurred,
            count: count,
            setHasOccurred: setHasOccurred,
            incrementCount: incrementCount
        };
    }, [
        count,
        hasOccurred,
        incrementCount,
        setHasOccurred
    ]);
};
export function useRecordMilestoneOnce() {
    var milestones = useMilestonesData();
    var record = useRecordMilestone();
    return useCallback(function(milestoneType) {
        var _milestones_milestoneType;
        if (!(milestones === null || milestones === void 0 ? void 0 : (_milestones_milestoneType = milestones[milestoneType]) === null || _milestones_milestoneType === void 0 ? void 0 : _milestones_milestoneType.count)) {
            return record(milestoneType);
        }
        return Promise.resolve();
    }, [
        milestones,
        record
    ]);
}
export function useRecordMilestoneByDay() {
    var milestones = useMilestonesData();
    var record = useRecordMilestone();
    return useCallback(function(milestoneType) {
        var milestone = milestones === null || milestones === void 0 ? void 0 : milestones[milestoneType];
        if (!(milestone === null || milestone === void 0 ? void 0 : milestone.count)) {
            return record(milestoneType);
        }
        var _milestone_updated_at;
        var updatedAt = (_milestone_updated_at = milestone === null || milestone === void 0 ? void 0 : milestone.updated_at) !== null && _milestone_updated_at !== void 0 ? _milestone_updated_at : 0;
        var now = Date.now();
        if (differenceInDays(now, updatedAt) >= 1) {
            return record(milestoneType);
        }
        return Promise.resolve();
    }, [
        milestones,
        record
    ]);
}
export function useIsMilestoneOverWeekOld(milestoneType) {
    return useIsMilestoneOverDaysOld(milestoneType, 7);
}
export function useIsMilestoneOverDaysOld(milestoneType, days) {
    var _useMilestonesData;
    var milestone = (_useMilestonesData = useMilestonesData()) === null || _useMilestonesData === void 0 ? void 0 : _useMilestonesData[milestoneType];
    if (!(milestone === null || milestone === void 0 ? void 0 : milestone.count)) {
        return false;
    }
    var _milestone_updated_at;
    var updatedAt = (_milestone_updated_at = milestone === null || milestone === void 0 ? void 0 : milestone.updated_at) !== null && _milestone_updated_at !== void 0 ? _milestone_updated_at : 0;
    var now = Date.now();
    if (differenceInDays(now, updatedAt) >= days) {
        return true;
    }
    return false;
}
